import {
  IApiResponse,
  ICreateZoneRequest,
  ICreateZoneResponse,
  IDeleteByIdRequest,
  IDeleteZoneResponse,
  IGetAllZonesResponse,
  IGetByIdRequest,
  IGetZoneByIdResponse,
  IGetZoneLineRequest,
  IPaginationRequest,
  IUpdateZoneRequest,
  IUpdateZoneResponse,
  IZoneLine,
} from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";
const prefix = PREFIX.masterData;
const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};

const URL_GET_ALL_ZONE = getUrl("get-all-zones");
const URL_GET_ZONE_BY_ID = getUrl("get-zone-by-id");
const URL_CREATE_ZONE = getUrl("create-zone");
const URL_UPDATE_ZONE = getUrl("update-zone");
const URL_DELETE_ZONE = getUrl("delete-zone");
const URL_GET_ZONE_LINE = getUrl("get-zone-line");

class ZoneApiService extends BaseApiService {
  public getAllZones = (request: IPaginationRequest) =>
    this.get<IGetAllZonesResponse>(URL_GET_ALL_ZONE, {
      params: request,
    });
  public getZoneById = (request: IGetByIdRequest) =>
    this.get<IGetZoneByIdResponse>(URL_GET_ZONE_BY_ID, {
      params: request,
    });
  public createZone = (request: ICreateZoneRequest) =>
    this.post<ICreateZoneRequest, ICreateZoneResponse>(
      URL_CREATE_ZONE,
      request
    );
  public updateZone = (request: IUpdateZoneRequest) =>
    this.put<IUpdateZoneRequest, IUpdateZoneResponse>(URL_UPDATE_ZONE, request);
  public deleteZone = (request: IDeleteByIdRequest) =>
    this.delete<IDeleteZoneResponse>(URL_DELETE_ZONE, {
      params: request,
    });

  public getAllZoneLines = (request: IGetZoneLineRequest) =>
    this.get<IApiResponse<IZoneLine[]>>(URL_GET_ZONE_LINE, { params: request });
}

export default new ZoneApiService();
